<template>
  <div class="passwordDialog">
    <my-dialog :loading="loading" v-model="show" class-name="vertical-center-modal" @ok="ok" @cancel="cancel" title="联系方式">
        <Form :label-width="0" class="hr-tools-form" ref="form" :model="form" :rules="ruleValidate">
            <FormItem class="cus-item-form" prop="companyName">
                <div class="cus-item-label clearfix">
                    <div class="i-label">公司名称：</div>
                    <Input style="width:300px;" placeholder="请输入公司名称" v-model="form.companyName" :maxlength="50"></Input>
                </div>
            </FormItem>
            <FormItem class="cus-item-form" prop="name">
                <div class="cus-item-label clearfix">
                    <div class="i-label">姓&#12288;&#12288;名：</div>
                    <Input style="width:300px;" placeholder="请输入姓名" v-model="form.name" :maxlength="50"></Input>
                </div>
            </FormItem>
            <FormItem class="cus-item-form" prop="mobile">
                <div class="cus-item-label clearfix">
                    <div class="i-label">手&#12288;&#12288;机：</div>
                    <Input style="width:300px;" placeholder="请输入手机号" v-model="form.mobile" :maxlength="11"></Input>
                </div>
            </FormItem>
        </Form>
    </my-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cus-item-form {
  margin-left: 20px;
}
</style>

<script>
import myDialog from "@/components/myDialog";
import DB from "@/common/db";

export default {
  name: "unloginBuyDialog",
  props: ["desc", "code"],
  data() {
    const validateMobile = (rule, value, cb) => {
      if (!/^1[0-9]{10}$/.test(value)) {
        cb(new Error("请输入正确的格式"));
      } else {
        cb();
      }
    };
    return {
      show: true,
      loading: false,
      submitting: null,
      form: {
        companyName: null,
        name: null,
        mobile: null
      },
      ruleValidate: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            type: "string",
            max: 50,
            message: "公司名称最多不能超过50个字符",
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            type: "string",
            max: 50,
            message: "姓名最多不能超过50个字符",
            trigger: "blur"
          }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    ok() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.submitting = DB.request({
            url: DB.prefix + "biz/package/buyServiceIntention",
            type: "POST",
            showMessage: false,
            data: {
              code: this.code,
              desc: this.desc,
              ...this.form
            },
            success: res => {
              this.cancel();
              this.$emit("openServiceSuccess", res.data || {});
            },
            complete: () => {
              this.submitting = false;
            }
          });
        }
      });
    },
    cancel() {
      this.show = false;
      this.$emit("input", this.show);
    }
  },
  created() {},
  mounted() {},
  components: {
    myDialog
  }
};
</script>



// WEBPACK FOOTER //
// src/components/unloginBuyService.vue